import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ROUTES } from '../../common-files/enums/server-routes';

// Central room catalogue API calls (organisation -> premises -> guest house ->
// room, plus the per-day instances). CENTRAL-scoped.
@Injectable({ providedIn: 'root' })
export class CentralCatalogueService {
  constructor(private http: HttpClient) {}

  // -- organisations --
  listOrganisations(): Observable<any> {
    return this.http.get(ROUTES.CC_ORGANISATIONS);
  }

  addOrganisation(payload: any): Observable<any> {
    return this.http.post(ROUTES.CC_ORGANISATIONS, payload);
  }

  updateOrganisation(orgId: number, payload: any): Observable<any> {
    return this.http.put(`${ROUTES.CC_ORGANISATIONS}/${orgId}`, payload);
  }

  // -- premises --
  listPremises(orgId?: number): Observable<any> {
    const params: any = {};
    if (orgId) params.orgId = orgId;
    return this.http.get(ROUTES.CC_PREMISES, { params });
  }

  addPremises(payload: any): Observable<any> {
    return this.http.post(ROUTES.CC_PREMISES, payload);
  }

  updatePremises(premisesId: number, payload: any): Observable<any> {
    return this.http.put(`${ROUTES.CC_PREMISES}/${premisesId}`, payload);
  }

  // -- guest houses / dormitories (accommodation sets) --
  listSets(premisesId?: number, type?: string): Observable<any> {
    const params: any = {};
    if (premisesId) params.premisesId = premisesId;
    if (type) params.type = type;
    return this.http.get(ROUTES.CC_SETS, { params });
  }

  addSet(payload: any): Observable<any> {
    return this.http.post(ROUTES.CC_SETS, payload);
  }

  updateSet(setId: number, payload: any): Observable<any> {
    return this.http.put(`${ROUTES.CC_SETS}/${setId}`, payload);
  }

  setSetStates(payload: any): Observable<any> {
    return this.http.post(`${ROUTES.CC_SETS}/state`, payload);
  }

  // -- rooms / halls (accommodations) --
  listAccommodations(setId?: number): Observable<any> {
    const params: any = {};
    if (setId) params.setId = setId;
    return this.http.get(ROUTES.CC_ACCOMMODATIONS, { params });
  }

  addAccommodation(payload: any): Observable<any> {
    return this.http.post(ROUTES.CC_ACCOMMODATIONS, payload);
  }

  updateAccommodation(accommodationId: number, payload: any): Observable<any> {
    return this.http.put(`${ROUTES.CC_ACCOMMODATIONS}/${accommodationId}`, payload);
  }

  setAccommodationStates(payload: any): Observable<any> {
    return this.http.post(`${ROUTES.CC_ACCOMMODATIONS}/state`, payload);
  }

  setUtsavConfig(payload: any): Observable<any> {
    return this.http.post(`${ROUTES.CC_ACCOMMODATIONS}/utsav-config`, payload);
  }

  setRegularConfig(payload: any): Observable<any> {
    return this.http.post(`${ROUTES.CC_ACCOMMODATIONS}/regular-config`, payload);
  }

  // -- per-day instances --
  listInstances(date: string): Observable<any> {
    return this.http.get(ROUTES.CC_INSTANCES, { params: { date } });
  }

  blockInstances(payload: any): Observable<any> {
    return this.http.post(`${ROUTES.CC_INSTANCES}/block`, payload);
  }

  generateInstances(): Observable<any> {
    return this.http.post(`${ROUTES.CC_INSTANCES}/generate`, {});
  }

  // -- shared --
  getStatusReasons(): Observable<any> {
    return this.http.get(ROUTES.CC_STATUS_REASONS);
  }
}
